import { FormsTable } from 'components';

export default function MyDrafts() {
  return <FormsTable persistentListParametersStateKey='myDrafts' title='My Drafts' />;
}
